import { Tooltip } from '@color/continuum';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';

interface NotesIconProps {
  notes: string;
  'data-testid': string;
}

export function NotesIcon(props: NotesIconProps) {
  return (
    <Tooltip title={props.notes} slotProps={{ popper: { disablePortal: false } }}>
      <StickyNote2OutlinedIcon
        fontSize="small"
        data-testid={props['data-testid']}
        sx={{ color: 'info.main' }}
      />
    </Tooltip>
  );
}
